import {invokeAPI} from './commonBusiness';
import {setAvailableRoles, setAvailableRoleRights} from '../actions/userManagementAction';
import {SignalRHub, SignalREvent, UserRoleLevel} from '../../constants/dataEnum';
import {setDefaultViewSettings} from '../actions/protocolExplorerAction';
// eslint-disable-next-line import/no-cycle
import {getFastInstrumentTypeAsInt} from './instrumentStatusBusiness';

export const fetchUsers = () => (dispatch) => dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_USERS));

export const fetchActiveUsers = (userIds) => (dispatch) =>
  dispatch(invokeAPI(SignalRHub.SESSION, SignalREvent.GET_ACTIVE_USERS, userIds));

export const updateUser = (editedUser) => (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {user} = sessionState;
  const {userId} = user;

  return dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.UPDATE_USER, userId, editedUser));
};

export const updateUserNameAndEmail = (editedUser) => (dispatch) =>
  dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.UPDATE_USER_NAME_AND_EMAIL, editedUser));

export const createUser =
  (inputUsername, inputPassword, inputName, inputEmail, roleName, isActive) => (dispatch, getState) => {
    const state = getState();
    const {sessionState} = state;
    const {user} = sessionState;
    const {userId} = user;

    return dispatch(
      invokeAPI(
        SignalRHub.USER_MANAGEMENT,
        SignalREvent.CREATE_USER,
        userId,
        inputUsername,
        inputPassword,
        inputName,
        inputEmail,
        roleName,
        isActive,
      ),
    );
  };

export const changePassword = (id, oldPassword, newPassword) => async (dispatch) => {
  const result = await dispatch(
    invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.CHANGE_PASSWORD, id, oldPassword, newPassword),
  );

  return result;
};

export const deleteUsers = (userIds) => (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {user} = sessionState;
  const {userId} = user;

  return dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.DELETE_USERS, userId, userIds));
};

export const deleteUserWithoutTransferOwnership = (deletedUserId) => (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {user} = sessionState;
  const {userId} = user;

  return dispatch(
    invokeAPI(
      SignalRHub.PROTOCOL_MANAGEMENT,
      SignalREvent.DELETE_USER_WITHOUT_TRANSFER_OWNERSHIP,
      userId,
      deletedUserId,
    ),
  );
};

export const deleteUserAndTransferOwnership = (deletedUserId, targetUserId) => (dispatch, getState) => {
  const state = getState();
  const {sessionState} = state;
  const {user} = sessionState;
  const {userId} = user;

  return dispatch(
    invokeAPI(
      SignalRHub.PROTOCOL_MANAGEMENT,
      SignalREvent.DELETE_USER_AND_TRANSFER_OWNERSHIP,
      userId,
      deletedUserId,
      targetUserId,
    ),
  );
};

export const fetchAvailableRoles = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_ROLES));

  dispatch(setAvailableRoles(response));
};

export const fetchAvailableRoleRights =
  (id, isSetRightsToState = true) =>
  async (dispatch) => {
    const instrumentType = getFastInstrumentTypeAsInt();

    const response = await dispatch(
      invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_ROLE_GROUP_RIGHTS_DATA_BY_ROLE_ID, id, instrumentType),
    );

    if (isSetRightsToState) dispatch(setAvailableRoleRights(response));

    return response;
  };

export const fetchUsersByRoleLevel = (level, callback) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_USERS_BY_ROLE_LEVEL, level));

  if (callback) return callback(response);
  return response;
};

export const getUserRoleLevel = (userParam) => (dispatch, getState) => {
  const {sessionState} = getState();
  const {user: userSession} = sessionState || {};

  const user = userParam || userSession;

  const userRoleID = user?.userRole || {};

  // role level starts from index 0, role id starts from 1
  return Number(userRoleID) - 1 || 0;
};

export const isUserOperator = () => (dispatch) => {
  const roleLevel = dispatch(getUserRoleLevel());
  if (roleLevel === UserRoleLevel.OPERATOR) {
    return true;
  }
  return false;
};

export const isRoleLevel = (userRoleLevel) => (dispatch) => {
  const roleLevel = dispatch(getUserRoleLevel());

  if (roleLevel === userRoleLevel) {
    return true;
  }
  return false;
};

export const checkTessaraUser = () => (dispatch, getState) => {
  const {licenseState} = getState();
  const {isTessaraInstrument} = licenseState || {};

  const isTessaraSuperUser = dispatch(isRoleLevel(UserRoleLevel.TESSARA_SUPER_USER));

  return {
    isTessaraSuperUser: isTessaraSuperUser && isTessaraInstrument,
    isTessaraRegularUser: !isTessaraSuperUser && isTessaraInstrument,
    isTessaraInstrument,
  };
};

export const isAutoSaveProtocol = () => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {userId} = sessionState.user;

  const response = await dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.IS_AUTO_SAVE_PROTOCOL, userId));

  return response;
};

export const setAutoSaveProtocol = (autosaveState) => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {userId} = sessionState.user;

  const response = await dispatch(
    invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.SET_AUTO_SAVE_PROTOCOL, userId, autosaveState),
  );

  return response;
};

export const setExplorerViewSettings = (viewMode) => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {userId} = sessionState.user;

  const response = await dispatch(
    invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.SET_EXPLORER_VIEW_SETTING, userId, viewMode),
  );

  dispatch(setDefaultViewSettings({explorerViewMode: viewMode}));

  return response;
};

export const fetchExplorerViewSettings = (userId) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_EXPLORER_VIEW_SETTING, userId),
  );

  const {explorerViewMode} = response;
  dispatch(setDefaultViewSettings({explorerViewMode}));

  return response;
};
